import React from "react";
import { List, ListChecks } from "lucide-react";
import { RaboButton } from "../rabo-button";

/** Bulgular / Aksiyonlar alt geçişi — Risk Center Files sekmesiyle aynı RaboButton stili. */
export function ModuleViewToggle({
  activeView,
  onSelectFindings,
  onSelectActions,
  findingsLabel,
  actionsLabel,
  className,
}) {
  return (
    <div className={`flex items-center gap-2 flex-shrink-0 ${className || ""}`}>
      <RaboButton
        variant={activeView === "findings" ? "dark" : "outline"}
        size="sm"
        onClick={onSelectFindings}
      >
        <List className="w-4 h-4" strokeWidth={2} />
        {findingsLabel}
      </RaboButton>
      <RaboButton
        variant={activeView === "actions" ? "dark" : "outline"}
        size="sm"
        onClick={onSelectActions}
      >
        <ListChecks className="w-4 h-4" strokeWidth={2} />
        {actionsLabel}
      </RaboButton>
    </div>
  );
}
